document.addEventListener("performize_push_data_layer", function(e) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(e.detail);
})